import {InputBase, Stack, Typography} from "@mui/material";
import {ChangeEvent, useEffect, useState} from "react";

export interface Props {
    value: number | null;
    setValue: (value: number | null) => void;
    clear: boolean;
}

export const DataUploadTextInput: React.FC<Props> = ({value, setValue, clear}) => {
    const [active, setActive] = useState(false);
    const [border, setBorder] = useState("");
    const [color, setColor] = useState("");

    const valueChanged = (event: ChangeEvent<HTMLInputElement>) => {
        const input = event.target.value.trim();
        if (input === "") {
            setActive(true);
            setValue(null);
            return;
        }
        let parsed = Number(input);
        if (isNaN(parsed)) {
            event.target.value = "";
            setActive(true);
            setValue(null);
            return;
        }

        if (parsed > 999) {
            parsed = 999;
            event.target.value = "999";
        } else if (parsed < 0) {
            event.target.value = "";
            setActive(true);
            setValue(null);
            return;
        }
        setActive(true);
        setValue(parsed);
    };

    useEffect(() => {
        setBorder(active ? "1px solid #8B9ADA" : "1px solid #E9EBF1");
        setColor(active ? "#3A3F4F" : "#8F94A8");
    }, [active]);

    useEffect(() => {
        if (clear) {
            setActive(false);
            setValue(null);
        }
    }, [clear, setValue]);

    return (
        <Stack sx={{mr: "0.5rem", position: "relative"}}>
            <Stack
                sx={{
                    height: "24px",
                    border,
                    borderRadius: "3px",
                    backgroundColor: "#FFFFFF",
                    padding: "1px 9px",
                }}
            >
                <InputBase
                    size="small"
                    margin="none"
                    value={value ?? ""}
                    onChange={valueChanged}
                    sx={{
                        color,
                        fontSize: "16px",
                        fontWeight: "700",
                        marginLeft: "10px",
                        marginRight: "5px",
                    }}
                />
            </Stack>

            <Typography
                fontSize={14}
                fontWeight={400}
                sx={{right: "8px", top: "4px", color: "#545A6E", position: "absolute"}}
            >
                mm
            </Typography>
        </Stack>
    );
};
